import React from 'react';
import { Link } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import { CompanyModel, MembershipModel } from 'services/EpdClient';
import styled, { css } from 'styled-components';
import { media } from './components/headerHelpers';

interface Props {
  company: CompanyModel;
  memberships: MembershipModel[];
  hasCompanyAccess: boolean;
}

const HeaderUserCompanyInfo: React.FC<Props> = ({ company, memberships, hasCompanyAccess }) => {
  const orderedMemberships = memberships.filter((x) => x.companyId === company.id);
  const distinctRoles = orderedMemberships.map((m) => m.roleName).filter((x, i, arr) => arr.indexOf(x) === i);

  return (
    <Wrapper disabled={!hasCompanyAccess}>
      <StyledLink to={hasCompanyAccess ? EpdLinks.manageCompany(company.id!) : '#'} disabled={!hasCompanyAccess}>
        <NameText>{company.name}</NameText>
        {distinctRoles.length > 0 && <RoleText>{distinctRoles.join(', ')}</RoleText>}
      </StyledLink>
    </Wrapper>
  );
};

export default HeaderUserCompanyInfo;

const Wrapper = styled.div.attrs((props: { disabled: boolean }) => ({ disabled: props.disabled ?? false }))`
  padding: 11px 16px;

  ${(props) =>
    props.disabled
      ? ''
      : css`
          &:hover {
            background-color: rgba(180, 208, 182, 0.3);
          }
        `}

  @media ${media.TABLET_OR_MORE} {
    max-width: 260px;
  }
`;

const StyledLink = styled(Link).attrs((props: { disabled: boolean }) => ({ disabled: props.disabled ?? false }))`
  color: black;
  text-decoration: none;
  ${(props) =>
    props.disabled
      ? css`
          cursor: default;
        `
      : ''}
`;

const NameText = styled.div`
  font-weight: 600;
`;

const RoleText = styled.div`
  color: ${(props) => props.theme.colors.primaryBlack70};
  margin-top: 8px;
`;
